import { useState } from 'react';
import { Button, SimpleGrid, ListItem, List } from '@chakra-ui/react';
import { mapTeaserServiceProps } from '../../lib/resolvers';
import Teaser from '../Teaser';
import { SelectedServiceField } from '../../types';
import Heading from '../Heading';
import { useTranslation } from '../../lib/hooks.context';
import { isArrayOfStrings } from '../../lib/utils';

const SelectedServices = ({ services, categories }: SelectedServiceField) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const t = useTranslation();

  if (!services?.length) {
    return null;
  }

  const shownServices = selectedCategory
    ? services?.filter(
        ({ categories: cats }) =>
          isArrayOfStrings(cats) && cats.includes(selectedCategory),
      )
    : services;

  return (
    <section data-test-id="section selected-services">
      <Heading variant="h5" mb="8">
        {t('services')}
      </Heading>
      <List display="flex" listStyleType="none" flexWrap="wrap" p={0} m={0}>
        <ListItem key="all" mb={3} mr={3}>
          <Button
            onClick={() => setSelectedCategory(null)}
            {...(selectedCategory === null ? { 'data-selected': true } : null)}
          >
            {t('services_all')}
          </Button>
        </ListItem>
        {categories &&
          categories.map(({ slug, name }) => (
            <ListItem key={slug} mb={3} mr={3}>
              <Button
                onClick={() => setSelectedCategory(slug)}
                {...(selectedCategory === slug
                  ? { 'data-selected': true }
                  : null)}
              >
                {name}
              </Button>
            </ListItem>
          ))}
      </List>
      <SimpleGrid layerStyle={['smGrid', 'sectionPaddingSm']}>
        {shownServices &&
          shownServices.map((entry) => (
            <Teaser key={entry.ID} {...mapTeaserServiceProps(entry, t)} />
          ))}
      </SimpleGrid>
    </section>
  );
};
export default SelectedServices;
